import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/evse_group.png'


const _hoisted_1 = { class: "evse evse-details details" }
const _hoisted_2 = { class: "detail-top" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { class: "section-header__block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "90"
  })
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "app-wrapper" }

import { computed } from 'vue'
import EssDeviceInfo from '@/components/EssDeviceInfo.vue'
import { ElMessageBox as MB, ElMessage } from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import DetailHeader from '@/components/DetailHeader.vue'
import Evses from '@/views/Evses/Evses.vue'
import Orders from '@/views/Orders/Orders.vue'
import PricingTable from '@/views/Pricing/components/PricingTable.vue'
// import Pricing from '@/views/Pricing/pricing.vue'
import { getStationInfo, openStation } from '@/api/operation'
import StationOverview from './components/StationOverview.vue'
import BarrierGate from './components/BarrierGate.vue'
import StationWhiteList from './components/StationWhiteList.vue'
import StationSettings from './components/StationSettings.vue'
import StationUpsert from './components/StationUpsert.vue'
import { Country, StationNature } from '@/types/types'
import EvseConnectors from '@/views/Evses/components/EvseConnectors.vue'
import useI18nTl from '@/hooks/useI18nTl'
import EssDevice from '@/views/Evses/EssDevice.vue'
import Strategys from '@/views/ProfitSharing/Strategys.vue'

import { defineComponent, ref } from 'vue'
import { info } from '@/api/common'
import StrategysTable from '../ProfitSharing/components/StrategysTable.vue'
const __default__ = defineComponent({
  name: 'StationDetails',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')

const route = useRoute()
const router = useRouter()
const evseDetailLock = ref(false)

const station = ref<Record<string, any>>({})
const currTab = ref('overview')
const stationid = computed(function () {
  const id = route.params.id
  return Array.isArray(id) ? id[0] : id
})

const showDialog = ref(false)
const showDialogStation = ref({})
const editStation = () => {
  showDialogStation.value = station.value
  showDialog.value = true
}

const hasEvseNature = computed(() => {
  return (station.value.stationNature & StationNature.SN_EVSE) == StationNature.SN_EVSE
})
const hasPvesOrEssNature = computed(
  () =>
    (station.value.stationNature & StationNature.SN_PVES) == StationNature.SN_PVES ||
    (station.value.stationNature & StationNature.SN_ESS) == StationNature.SN_ESS,
)
const loadData = async function () {
  getStationInfo({
    id: stationid.value,
  })
    .then((res: any) => {
      station.value = res.info
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}
const handleRefresh = async () => {}
const updateEnable = () => {
  openStation(station.value.id, station.value.isOpen)
}

const handleDelete = async function () {}

const initData = async () => {
  await loadData()
}

initData()

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DetailHeader, {
        item: { name: station.value.name }
      }, null, 8, ["item"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createVNode(_component_el_descriptions, {
              column: 3,
              style: {"padding-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, {
                  width: "250px",
                  label: _ctx.$t('Operation.operator') + ' : '
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(station.value.operatorName), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  width: "350px",
                  label: _ctx.$t('Operation.contacts') + ' : '
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      content: station.value.contactName,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(station.value.contactPhone ? station.value.contactPhone : station.value.contactEmail), 1)
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  width: "400px",
                  label: _ctx.$t('Operation.maxLoad') + ' : '
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(station.value.powerMax) + " KW / " + _toDisplayString(station.value.currentMax) + " A", 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  width: "400px",
                  label: _unref(t)('Base.address') + ' : '
                }, {
                  default: _withCtx(() => [
                    (station.value.country == _unref(Country).CY_CHINA)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(station.value.areaCode) + ", " + _toDisplayString(station.value.address), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(station.value.address) + "," + _toDisplayString(station.value.areaCode), 1))
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_tooltip, {
            content: station.value.isOpen ? _ctx.$t('Base.enable') : _ctx.$t('Base.disable'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                class: "enable-btn",
                disabled: !_ctx.$hasPermission('post'),
                modelValue: station.value.isOpen,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((station.value.isOpen) = $event)),
                onChange: updateEnable
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_el_tooltip, {
            content: _ctx.$t('Base.edit'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "icon-button",
                disabled: !_ctx.$hasPermission('post'),
                type: "primary",
                icon: _unref(Edit),
                plain: "",
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editStation()))
              }, null, 8, ["disabled", "icon"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
      class: "detail-tabs",
      modelValue: currTab.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('Base.overview'),
            name: "overview",
            lazy: true
          }, {
            default: _withCtx(() => [
              (_unref(hasPvesOrEssNature))
                ? (_openBlock(), _createBlock(EssDeviceInfo, {
                    key: 0,
                    style: {"margin":"20px 0"},
                    opeartorID: station.value.operatorID,
                    stationID: _unref(stationid),
                    stationInfo: station.value
                  }, null, 8, ["opeartorID", "stationID", "stationInfo"]))
                : _createCommentVNode("", true),
              (_unref(hasEvseNature))
                ? (_openBlock(), _createBlock(StationOverview, {
                    key: 1,
                    stationID: station.value.id
                  }, null, 8, ["stationID"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          (_unref(hasEvseNature))
            ? _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: _ctx.$t('components.chargeEvses'),
                name: "evses",
                lazy: true
              }, {
                default: _withCtx(() => [
                  _createVNode(Evses, {
                    opeartorID: station.value.operatorID,
                    stationID: station.value.id,
                    showDownloadBtn: true
                  }, null, 8, ["opeartorID", "stationID"])
                ]),
                _: 1
              }, 8, ["label"])), [
                [_directive_role, 'evses']
              ])
            : _createCommentVNode("", true),
          (_unref(hasPvesOrEssNature))
            ? _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                label: _ctx.$t('components.pvEvses'),
                name: "pvEvses",
                lazy: true
              }, {
                default: _withCtx(() => [
                  _createVNode(EssDevice, {
                    opeartorID: station.value.operatorID,
                    stationID: station.value.id,
                    showDownloadBtn: true
                  }, null, 8, ["opeartorID", "stationID"])
                ]),
                _: 1
              }, 8, ["label"])), [
                [_directive_role, 'evses']
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('components.sessions'),
            name: "sessions",
            lazy: true
          }, {
            default: _withCtx(() => [
              _createVNode(Orders, {
                stationID: station.value.id
              }, null, 8, ["stationID"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'sessions']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('components.barrierGate'),
            name: "barrierGate",
            lazy: true
          }, {
            default: _withCtx(() => [
              _createVNode(BarrierGate, { station: station.value }, null, 8, ["station"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'barrierGate']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('components.stationWhiteList'),
            name: "stationWhiteList",
            lazy: true
          }, {
            default: _withCtx(() => [
              _createVNode(StationWhiteList, {
                stationID: station.value.id,
                operatorID: station.value.operatorID
              }, null, 8, ["stationID", "operatorID"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'stationWhiteList']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('components.pricingTariff'),
            name: "pricingTariff",
            lazy: true
          }, {
            default: _withCtx(() => [
              _createVNode(PricingTable, {
                "station-id": station.value.id,
                "operator-id": station.value.operatorID
              }, null, 8, ["station-id", "operator-id"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'priceingUpsert']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('components.strategyList'),
            name: "strategyList",
            lazy: true
          }, {
            default: _withCtx(() => [
              _createVNode(StrategysTable, {
                "station-id": station.value.id,
                "operator-id": station.value.operatorID
              }, null, 8, ["station-id", "operator-id"])
            ]),
            _: 1
          }, 8, ["label"])), [
            [_directive_role, 'strategyAdd']
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])), [
      [
        _directive_loading,
        evseDetailLock.value,
        void 0,
        { lock: true }
      ]
    ]),
    _createVNode(StationUpsert, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      showType: "edit",
      showData: showDialogStation.value,
      onSubmitted: loadData
    }, null, 8, ["modelValue", "showData"])
  ]))
}
}

})